import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { MustSeeShowsBlock } from './must-see-shows-block';
import { Component, HostBinding, inject } from '@angular/core';
import { MediaUiModule } from '../media-ui.module';
import { ApiHomeRow, PagesApi } from '@tytapp/api';
import { firstValueFrom } from 'rxjs';
import { LoggerService } from '@tytapp/common';

@Component({
    selector: 'tyt-must-see-shows-block',
    standalone: true,
    imports: [ ContentModule, MediaUiModule ],
    template: `
        @if (row) {
            <tyt-topic-card
                [topic]="row"
                title="Today's Must See Shows"
                [icon]="{ type: 'material', text: 'star' }"
                />
        } @else {
            <app-spinner />
        }
    `,
    styles: [`
        // TODO
    `]
})
export class ViewComponent extends ContentBlockViewComponent<MustSeeShowsBlock> {
    private pageApi = inject(PagesApi);
    private logger = inject(LoggerService).configure({ source: 'must-see-block' });

    row: ApiHomeRow;

    @HostBinding('class.animate-in')
    animatedIn = false;

    async ngOnInit() {
        try {
            this.row = await firstValueFrom(this.pageApi.getMustSee());
            setTimeout(() => this.animatedIn = true, 100);
        } catch (e) {
            this.logger.error(`Must See: Failed to fetch content`, e);
        }
    }
}
